import React from 'react'
import {
  GET_INVOICES_SUCCESS,
  QUANTITY_CHANGE,
  QUANTITY_PRICE_CHANGE,
  REMOVE_INVOICE,
  WARN_INVOICE_TO_DELETE,
  CANCEL_DELETE_INVOICE,
  COPY_INVOICE_SUCCESS,
  INVOICE_PAGE_CHANGE,
  GET_INVOICE_BY_ID_SUCCESS,
  CANCEL_EDIT_INVOICE,
  INVOICE_EDIT_SUCCESS,
  GET_OPERATOR_SUCCESS,
  SHOW_TOOLTIP,
  HIDE_TOOLTIP,
  ENABLE_EXPENSE_BACK_BTN,
  ENABLE_ALLOWANCE_BACK_BTN,
  DISABLE_EXPENSE_BACK_BTN,
  DISABLE_ALLOWANCE_BACK_BTN,
  LOCATION_CHANGE,
  GET_COUNTRY_LIST_SUCCESS,
  EDIT_AND_GO_TO_INVOICE,
  ENABLE_CANCEL_INVOICE,
  ADD_ALLOWANCES_TO_INVOICE,
  ADD_EXPENSES_TO_INVOICE,
  ADD_CREDIT_NOTE_SUCCESS,
  SET_ORIGINAL_INVOICE_ID,
  SAVE_INVOICE_SUCCESS,
  SAVE_AND_SEND_INVOICE_SUCCESS,
  REVIEW_INVOICE_EDIT_SUCCESS,
  REVIEW_INVOICE_EDIT_SEND_SUCCESS,
  ADD_CREDIT_NOTE_FAILED,
  GET_REGISTERED_USERS_LIST_SUCCESS,
  CLEAR_SELECTED_USER,
  GET_REGISTERED_USERS_LIST,
  GET_REGISTERED_USERS_LIST_FAILED,
  ATTACH_WORKSHIFT_JOURNAL_ID_SUCCESS,
  CLEAR_ATTACH_WORKSHIFT_JOURNAL_ID,
  SHOW_INVOICE_FORM_DIALOG,
  CLOSE_INVOICE_FORM_DIALOG,
  RESET_INVOICES,
  CLEAR_INVOICE_EDIT_VALUES
} from '../constants'
import { SESSION_TERMINATED, USER_EXPIRED } from 'redux-oidc'
import store from '../store'
import DateTimeFormat from '../utils/DateTimeFormat'
import InvoiceRow from '../components/invoice/invoiceRow.component'

const initialState = {
  expensesInvoiceRow: [],
  allowanceInvoiceRow: [],
  customers: [],
  invoiceRowCounter: 1,
  invoiceRows: [],
  invoices: [],
  selected: 0,
  invoiceEdit: [],
  isEdit: false,
  isCopy: false,
  invoiceOperators: [],
  hoveredTooltip: false,
  isToDelete: false,
  isToDeleteInvoiceId: 0,
  isToDetach_workshift_journal_id: '',
  account_number: '',
  enable_expense_back_btn: false,
  enable_allowance_back_btn: false,
  countryList: [],
  invoiceFormValues: null,
  preventCancelInvoice: false,
  originalInvoiceId: null,
  disable_quick_pay: false,
  registeredUsersList: [],
  getRegisteredUserSuccess: false,
  workshift_journal: [],
  attachedWorkShiftJournalIds: [],
  showInvoiceFormDialog: false
}

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        countryList: [...action.data]
      }

    case GET_REGISTERED_USERS_LIST:
    case GET_REGISTERED_USERS_LIST_FAILED:
      return {
        ...state,
        getRegisteredUserSuccess: false
      }

    case GET_REGISTERED_USERS_LIST_SUCCESS:
      const registeredEmail = state.registeredUsersList
      if (
        action.data?.uuid &&
        !registeredEmail.some((obj) => obj.uuid === action.data.uuid)
      ) {
        registeredEmail.push(action.data)
      }
      return {
        ...state,
        registeredUsersList: registeredEmail,
        getRegisteredUserSuccess: true
      }

    case SESSION_TERMINATED:
    case USER_EXPIRED:
      return Object.assign({}, { ...state }, { invoiceRows: [] })

    case GET_INVOICES_SUCCESS:
      // KAS-350 Rahoitus overdue handling
      const invoices = JSON.parse(action.invoices)
      const current_date = new Date()
      current_date.setHours(0, 0, 0, 0)
      const quick_pay_overdue = invoices.filter(
        (inv) =>
          inv.instant_payment === 'quick_pay' &&
          inv.status === 3 &&
          inv.remindersent === 1 &&
          current_date > new Date(inv.due_date)
      )

      let disable_quick_pay
      if (quick_pay_overdue.length >= 1) {
        disable_quick_pay = true
      } else {
        disable_quick_pay = false
      }

      return Object.assign(
        {},
        { ...state },
        {
          invoiceRows: _createInvoiceRow(
            JSON.parse(action.invoices),
            state.selected
          ),
          invoices: invoices,
          customers: JSON.parse(action.customerResult),
          disable_quick_pay: disable_quick_pay
        }
      )

    case ENABLE_EXPENSE_BACK_BTN:
      return Object.assign(
        {},
        { ...state },
        {
          enable_expense_back_btn: true,
          invoiceFormValues: action.formValues
        }
      )

    case ENABLE_ALLOWANCE_BACK_BTN:
      return Object.assign(
        {},
        { ...state },
        {
          enable_allowance_back_btn: true,
          invoiceFormValues: action.formValues
        }
      )

    case DISABLE_EXPENSE_BACK_BTN:
      return Object.assign(
        {},
        { ...state },
        {
          enable_expense_back_btn: false,
          invoiceFormValues: null
        }
      )

    case DISABLE_ALLOWANCE_BACK_BTN:
      return Object.assign(
        {},
        { ...state },
        {
          enable_allowance_back_btn: false,
          invoiceFormValues: null
        }
      )

    case GET_OPERATOR_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceOperators: action.operators
        }
      )

    case GET_INVOICE_BY_ID_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceEdit: JSON.parse(action.result),
          isEdit: true,
          originalInvoiceId: null
        }
      )

    case COPY_INVOICE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceEdit: JSON.parse(action.result),
          isEdit: true,
          isCopy: true
        }
      )

    case ADD_CREDIT_NOTE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceEdit: JSON.parse(action.result),
          isEdit: true
        }
      )

    case ADD_CREDIT_NOTE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceEdit: [],
          isEdit: false,
          originalInvoiceId: null
        }
      )

    case SET_ORIGINAL_INVOICE_ID:
      return Object.assign(
        {},
        { ...state },
        { originalInvoiceId: action.invoice_id }
      )

    case SAVE_INVOICE_SUCCESS:
    case SAVE_AND_SEND_INVOICE_SUCCESS:
    case REVIEW_INVOICE_EDIT_SUCCESS:
    case REVIEW_INVOICE_EDIT_SEND_SUCCESS:
      return Object.assign({}, { ...state }, { originalInvoiceId: null })

    case CANCEL_EDIT_INVOICE:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceEdit: [],
          isEdit: false,
          isCopy: false,
          preventCancelInvoice: false,
          originalInvoiceId: null,
          attachedWorkShiftJournalIds: []
        }
      )

    case ADD_ALLOWANCES_TO_INVOICE:
    case ADD_EXPENSES_TO_INVOICE:
      if (action.invoiceEdit) {
        return Object.assign(
          {},
          { ...state },
          {
            invoiceEdit: action.invoiceEdit,
            isEdit: true
          }
        )
      } else {
        return state
      }

    case EDIT_AND_GO_TO_INVOICE:
      if (action.invoiceEdit) {
        return Object.assign(
          {},
          { ...state },
          {
            preventCancelInvoice: true,
            invoiceEdit: action.invoiceEdit,
            isEdit: true
          }
        )
      } else {
        return Object.assign(
          {},
          { ...state },
          {
            preventCancelInvoice: true,
            isEdit: true
          }
        )
      }

    case ENABLE_CANCEL_INVOICE:
      return Object.assign(
        {},
        { ...state },
        {
          preventCancelInvoice: false
        }
      )

    case INVOICE_EDIT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceEdit: [],
          isEdit: false
        }
      )

    case CLEAR_INVOICE_EDIT_VALUES:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceEdit: []
        }
      )

    case REMOVE_INVOICE:
      return Object.assign({}, state, {
        invoices: state.invoices.filter(
          (el) => el.invoice_id !== action.invoice_id
        ),
        invoiceRows: _createInvoiceRow(
          state.invoices.filter((el) => el.invoice_id !== action.invoice_id),
          state.selected
        ),
        isToDelete: false,
        isToDeleteInvoiceId: 0,
        isToDetach_workshift_journal_id: ''
      })

    case WARN_INVOICE_TO_DELETE:
      return Object.assign(
        {},
        { ...state },
        {
          isToDelete: true,
          isToDeleteInvoiceId: action.selected,
          isToDetach_workshift_journal_id: action.attached_journal_id
        }
      )

    case CANCEL_DELETE_INVOICE:
      return Object.assign(
        {},
        { ...state },
        {
          isToDelete: false,
          isToDeleteInvoiceId: 0,
          isToDetach_workshift_journal_id: ''
        }
      )

    case QUANTITY_CHANGE:
      _calculateRowSum(action.rowNumber)
      return state

    case QUANTITY_PRICE_CHANGE:
      _calculateRowSum(action.rowNumber)
      return state

    case INVOICE_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceRows: _createInvoiceRow(
            state.invoices,
            action.selected.selected
          ),
          selected: action.selected.selected
        }
      )

    case ATTACH_WORKSHIFT_JOURNAL_ID_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          attachedWorkShiftJournalIds: action.result
        }
      )
    case CLEAR_ATTACH_WORKSHIFT_JOURNAL_ID:
      return Object.assign(
        {},
        { ...state },
        {
          attachedWorkShiftJournalIds: []
        }
      )

    case LOCATION_CHANGE:
      if (action.payload.pathname === '/dashboard/invoice') return state
      else return Object.assign({}, { ...state }, { selected: 0 })

    case SHOW_TOOLTIP:
      return Object.assign({}, { ...state }, { hoveredTooltip: true })

    case HIDE_TOOLTIP:
      return Object.assign({}, { ...state }, { hoveredTooltip: false })

    case CLEAR_SELECTED_USER:
      return Object.assign(
        {},
        { ...state },
        {
          invoices: []
        }
      )

    case SHOW_INVOICE_FORM_DIALOG:
      return Object.assign({}, state, {
        showInvoiceFormDialog: true
      })

    case CLOSE_INVOICE_FORM_DIALOG:
      return Object.assign({}, state, {
        showInvoiceFormDialog: false,
        isEdit: false
      })

    case RESET_INVOICES:
      return Object.assign(
        {},
        { ...state },
        {
          invoices: []
        }
      )

    default:
      return state
  }
}

const _calculateRowSum = (rowNumber) => {
  const formValues = getFormValues('invoice')(store.getState())

  const quantity = formValues['rows'][rowNumber]['quantity'] || '0'
  const formQuantity = parseFloat(quantity.replace(/,/g, '.'))

  const quantityPrice = formValues['rows'][rowNumber]['quantity_price'] || '0'
  const formQuantityPrice = parseFloat(quantityPrice.replace(/,/g, '.'))

  const sum = formQuantity * formQuantityPrice
  const vat = formValues['rows'][rowNumber]['vat_percent'] / 100

  formValues['rows'][rowNumber]['sum_tax_free'] = new Intl.NumberFormat(
    'fi-FI',
    {
      style: 'currency',
      currency: 'EUR'
    }
  ).format(sum)

  formValues['rows'][rowNumber]['vat'] = new Intl.NumberFormat('fi-FI', {
    style: 'currency',
    currency: 'EUR'
  }).format(sum * vat)

  formValues['rows'][rowNumber]['sum_with_vat'] = new Intl.NumberFormat(
    'fi-FI',
    {
      style: 'currency',
      currency: 'EUR'
    }
  ).format(sum * (vat + 1))

  formValues['rows'][rowNumber][
    'vat_percent_description'
  ] = `${formValues['rows'][rowNumber]['vat_percent']} %`
}

const _createInvoiceRow = (invoices, selected) =>
  invoices.slice(selected * 10, selected * 10 + 10).map((el, index) => (
    <InvoiceRow
      index={index}
      key={el.invoice_id}
      billing_date={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.billing_date))}
      due_date={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.due_date))}
      customer={el.company_name}
      invoice_id={el.invoice_id}
      totalSumWithVAT={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.total_sum)}
      instant_payment={el.instant_payment}
      status={el.status}
      remindersent={el.remindersent}
      is_group_invoice={el.is_group_invoice}
      functions=""
    />
  ))

export default invoiceReducer
